import React from 'react';
import LastPublications from './components/LastPublications/LastPublications';
import Navbar from '../navbar/Navbar';
import Publications from './components/Publications/Publications';
import Users from './components/Users/Users';
import Statistics from './components/Statistics/Statistics';
import { useSelector } from 'react-redux';
import { AddPublicationButton } from '../addPublicationButton/AddPublicationButton';
import Footer from '../footer/Footer';
import { selectFormattedUserEmail } from '../selectors/userSelectors';

function Dashboard() {
    const email = useSelector(selectFormattedUserEmail);

    return (
        <div className="container max-w-full">
            <div className="inline-flex flex-1 relative w-full self-stretch overflow-x-hidden">
                <div>
                    <Navbar />
                </div>
                <div className="w-full">
                    <div className="flex flex-col items-start relative h-full">
                        <div className="flex flex-col p-[40px_36px] w-full h-full">
                            <div className="flex items-center justify-between self-stretch relative w-full pb-6 border-b-0">
                                <div>
                                    <h1 className="font-heavy text-super-heavy text-dark-gray m-0 p-0">
                                        Bonjour {email}
                                    </h1>
                                    <p className="font-small text-medium text-gray m-0 p-0">
                                        Voici le résumé de vos utilisateurs et publications
                                    </p>
                                </div>
                                <AddPublicationButton></AddPublicationButton>
                            </div>
                            <div className="flex flex-grow gap-5 self-auto">
                                <div className="relative flex flex-grow w-1/3">
                                    <LastPublications />
                                </div>
                                <div className="flex flex-col flex-grow-[2] gap-5 w-2/3">
                                    <div className="inline-flex gap-5 -mr-5">
                                        <Publications />
                                        <Users />
                                    </div>
                                    <div className="flex flex-grow ">
                                        <Statistics />
                                    </div>
                                </div>
                            </div>
                            <div className="w-full myt-6 mt-8 ">
                                <Footer></Footer>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Dashboard;
